import { Link } from "react-router-dom";
import { FileEdit, PenLine, Bell } from "lucide-react";

/**
 * Compact navigation row for the signed-in Home page.
 * Pure links — no additional data fetching — surfacing the user's own
 * current SoundCheck content (new entry, drafts, activity).
 */
const links = [
  { to: "/reviews/new", label: "New entry", icon: PenLine },
  { to: "/profile/drafts", label: "Drafts", icon: FileEdit },
  { to: "/activity", label: "Activity", icon: Bell },
];

const HomeQuickLinks = () => (
  <nav
    aria-label="Your SoundCheck shortcuts"
    className="-mx-4 px-4 overflow-x-auto scrollbar-none"
  >
    <ul className="flex items-center gap-2 min-w-max">
      {links.map(({ to, label, icon: Icon }) => (
        <li key={to}>
          <Link
            to={to}
            className="inline-flex items-center gap-1.5 rounded-full bg-card ring-1 ring-border/50 px-3.5 h-9 text-[13px] text-foreground/80 hover:text-foreground hover:ring-border transition-colors whitespace-nowrap"
          >
            <Icon className="h-3.5 w-3.5 opacity-70" />
            {label}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

export default HomeQuickLinks;
